import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { GA4_APP_PLAY_GAME_EVENT } from "@/feature-analytics/google.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";

export async function onEnterLolGame(payload) {
  refs.gtag("event", GA4_APP_PLAY_GAME_EVENT, {
    ...(await refs.getIdentifyingInfo()),
    game: "lol",
  });

  return refs.trackEvent(ANALYTIC_EVENTS.LOL_START, payload);
}

export function onExitLolGame(payload) {
  return refs.trackEvent(
    ANALYTIC_EVENTS.LOL_END,
    Object.assign(
      {
        [refs.isImmediate]: true,
      },
      payload,
    ),
  );
}

export function onBuildImportFailed(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.LOL_BUILD_IMPORT_FAILED, payload);
}

// LCU import events
export function onSpellsImportError(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.LOL_IMPORT_ERROR_SPELLS, payload);
}
export function onSpellsImportSuccess(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.LOL_IMPORT_SUCCESS_SPELLS, payload);
}
export function onRunesImportError(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.LOL_IMPORT_ERROR_RUNES, payload);
}
export function onRunesImportSuccess(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.LOL_IMPORT_SUCCESS_RUNES, payload);
}

export function onArenaPostmatch(payload) {
  return refs.trackEvent(
    ANALYTIC_EVENTS.LOL_ARENA_POSTMATCH,
    Object.assign(
      {
        [refs.isImmediate]: true,
      },
      payload,
    ),
  );
}

export function onBrawlPostmatch(payload) {
  return refs.trackEvent(
    ANALYTIC_EVENTS.LOL_BRAWL_POSTMATCH,
    Object.assign(
      {
        [refs.isImmediate]: true,
      },
      payload,
    ),
  );
}

export function onAramMayhemPostmatch(payload) {
  return refs.trackEvent(
    ANALYTIC_EVENTS.LOL_ARAM_MAYHEM_POSTMATCH,
    Object.assign(
      {
        [refs.isImmediate]: true,
      },
      payload,
    ),
  );
}

export function onSeasonReview(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.LOL_SEASON_VIEW, payload);
}

export function onTimelineLoaded(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.LOL_TIMELINE_LOADED, payload);
}

export function onFriends(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.LOL_FRIENDS, payload);
}
